import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CategoryCard } from '../CompanyEvents/EventLibrary/style';
import { EventPointsWrapper } from '../MainEvents/styles';
import { withTranslation } from 'react-i18next';
import CreateChallengePoup from './challengeCreatePopup';
import LazyImage from './../common/LazyImage/LazyImage';
import { ImageUrl } from '../../utils/constants';
import {
  MonthlyChallengeSeries,
  CharityChallenges,
  SurvivorChallenges,
  ClassicChallenges
} from '../../utils/icons';

const categoryIconMap = {
  'classic challenge': ClassicChallenges,
  'charity challenge': CharityChallenges,
  'survivor challenge': SurvivorChallenges,
  'monthly challenge series': MonthlyChallengeSeries,
};

const categoryColorMap = {
  'classic challenge': '#FCF2F3',
  'charity challenge': '#F1F8F2',
  'survivor challenge': '#F5F6E8',
  'monthly challenge series': '#F2F5FB',
};

// ✅ NEW — BORDER COLOR MAP
const categoryBorderColorMap = {
  'classic challenge': '#E5B9BD',
  'charity challenge': '#A4D6A8',
  'survivor challenge': '#D6D9A4',
  'monthly challenge series': '#B8C6E3',
};

class ActivityCategory extends Component {

  resolveIconAndColor = (category) => {
    const rawName = category?.name ?? '';
    const rawType = category?.category_type ?? '';
    const rawId = category?.id ?? '';
    const rawNewIcon = category?.new_icon ?? '';
    const rawImage = category?.image ?? '';

    const nameKey = typeof rawName === 'string' ? rawName.trim().toLowerCase() : '';
    const typeKey = typeof rawType === 'string' ? rawType.trim().toLowerCase() : String(rawType).trim().toLowerCase();
    const idKey = String(rawId).trim().toLowerCase();

    let IconComponent =
      categoryIconMap[nameKey] ||
      categoryIconMap[typeKey] ||
      categoryIconMap[idKey] ||
      null;

    let bgColor =
      categoryColorMap[nameKey] ||
      categoryColorMap[typeKey] ||
      categoryColorMap[idKey] ||
      '#f2f2f2';

    let borderColor =
      categoryBorderColorMap[nameKey] ||
      categoryBorderColorMap[typeKey] ||
      categoryBorderColorMap[idKey] ||
      '#DCDCDC';

    // fallback matching based on prefix
    if (!IconComponent && rawName) {
      const lower = nameKey;
      for (const key of Object.keys(categoryIconMap)) {
        if (lower.startsWith(key)) {
          IconComponent = categoryIconMap[key];
          bgColor = categoryColorMap[key] || bgColor;
          borderColor = categoryBorderColorMap[key] || borderColor;
          break;
        }
      }
    }

    const fallbackIconUrl = rawNewIcon || rawImage || null;

    return { IconComponent, bgColor, borderColor, fallbackIconUrl };
  };

  render() {
    const { history, activityChallengeType, t } = this.props;

    return (
      <EventPointsWrapper margin gap={'12px 8px'}>
        {Array.isArray(activityChallengeType) &&
          activityChallengeType.length > 0 &&
          activityChallengeType.map((category, index) => {
            const { IconComponent, bgColor, borderColor, fallbackIconUrl } =
              this.resolveIconAndColor(category);

            return (
              <CategoryCard
                key={index}
                isCardRadius={'12px'}
                cardHeight='72px'
                isBorderRadius={'4px'}
                cardPadding={'12px 8px'}
                background={bgColor}
                style={{
                  border: `0.75px solid #dcdcdc`,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
                onClick={() => {
                  const target = category.category_type || category.id;
                  if (history?.location?.pathname === '/challenges/categories') {
                    history.push(`/challenges/categories/${target}`);
                  } else {
                    history.push(`/company/challenges/categories/${target}`);
                  }
                }}
              >
                <div
                  className="icon"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    border: `1px solid ${borderColor}`,
                    borderRadius: '6px',
                    padding: '4px',
                  }}
                >
                  {IconComponent &&
                  (typeof IconComponent === 'function' ||
                    typeof IconComponent === 'object') ? (
                      <IconComponent />
                    ) : fallbackIconUrl ? (
                      <LazyImage
                        div={'icon'}
                        src={
                          /^https?:\/\//i.test(fallbackIconUrl)
                            ? fallbackIconUrl
                            : `${ImageUrl}/${fallbackIconUrl}`
                        }
                      />
                    ) : (
                      <div
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: 6,
                          background: '#EAEAEA',
                        }}
                      />
                    )}
                </div>

                <div className="name" title={t(category.name)} style={{ marginLeft: 12 }}>
                  {t(category.name)}
                </div>
              </CategoryCard>
            );
          })}

        <CreateChallengePoup />
      </EventPointsWrapper>
    );
  }
}

ActivityCategory.propTypes = {
  history: PropTypes.object,
  activityChallengeType: PropTypes.array,
  role: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(ActivityCategory);
